import Button from 'components/button/Button'
import React from 'react'
import { buttons } from './CONTENT'
import { OperationsWrapper } from './elementStyled'
import { allIn } from '../functions/allIn'
import { SFXS } from 'index'
import { ReactComponent as MaxSVG } from '../../../assets/svg/maxStake.svg'
interface OPERATION_PROPS {
  balance: string
  maxStake: string
  minStake: string
  toFix: number
  audio: any
  colors: any
  makeMathOperation: any
  updateStake: any
  hasTenX?: any
}

export default function OperationButtons({
  colors,
  audio,
  makeMathOperation,
  balance,
  updateStake,
  maxStake,
  minStake,
  toFix,
  hasTenX,
}: OPERATION_PROPS) {
  const handleAllIn = () => {
    // console.log({ balance, maxStake })
    const all = allIn(balance, maxStake, minStake, toFix)
    // console.log(all)
    updateStake(all)
  }
  return (
    <OperationsWrapper textColor={colors.secondary}>
      {hasTenX
        ? buttons.map((b, i) => (
            <Button
              func={(e?: boolean) => makeMathOperation(e ? b.name : e)}
              longPressEnabled={b.longPressEnabled}
              key={i}
              audio={audio}
              SFX={b.SFX}
              borderColor={colors.secondary}
              textColor={colors.tertiary}
              background={colors.secondaryDark}
              size='16px'
            >
              {b.content}
            </Button>
          ))
        : buttons.slice(0, buttons.length - 1).map((b, i) => (
            <Button
              func={(e?: boolean) => makeMathOperation(e ? b.name : e)}
              longPressEnabled={b.longPressEnabled}
              key={i}
              audio={audio}
              SFX={b.SFX}
              borderColor={colors.secondary}
              textColor={colors.tertiary}
              background={colors.secondaryDark}
              size='16px'
            >
              {b.content}
            </Button>
          ))}
      <Button
        SFX={SFXS.multiplySFX}
        func={handleAllIn}
        borderColor={colors.secondary}
        background={colors.secondaryDark}
        textColor={colors.tertiary}
        size='16px'
      >
        <MaxSVG />
      </Button>
    </OperationsWrapper>
  )
}
